module.exports = __webpack_public_path__ + "src/img/more/art_of_fighters.31063.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/more/art_of_fighters.jpg
// module id = 103
// module chunks = 0